import type {
  ValidationResult,
  YachtGameState,
  YachtRollDiceAction,
} from "../types";
import {
  getOpenTurnSlot,
  invalid,
  valid,
  validateActionWindow,
} from "./common";

export function validateRollDice(
  state: YachtGameState,
  action: YachtRollDiceAction,
): ValidationResult {
  if (state.phase !== "ROLLING") {
    return invalid("Game is not rolling");
  }

  const slot = getOpenTurnSlot(state, action.playerId);
  if (!slot) {
    return invalid("Player does not have an open turn slot");
  }

  const windowValidation = validateActionWindow(slot, action);
  if (!windowValidation.valid) return windowValidation;

  if (slot.rollCount >= 3) {
    return invalid("Cannot roll after three rolls");
  }

  if (slot.rollCount === 0 && slot.held.some(Boolean)) {
    return invalid("First roll cannot start with held dice");
  }

  if (slot.rollCount > 0 && slot.held.every(Boolean)) {
    return invalid("At least one die must be available to roll");
  }

  return valid();
}
